<template>
  <v-container class="d-flex justify-center flex-column">


    <v-main v-if="isCurrentTabDos">
      <!-- Subir archivos  -->
      <v-row v-if="consultaNueva.length <= 0">
        <!-- Sección de subida de archivos  -->
        <v-row class="d-flex justify-center">
          <v-col cols="12">
            <v-card-title class="font-weight-bold display-1">Imágenes</v-card-title>
            <v-card-subtitle class="primary--text">
              Sube las imágenes que desees
            </v-card-subtitle>
          </v-col>
          <section class="pa-16 border-dashed-thin rounded-xl">
            <v-col cols="12" class="d-flex justify-center">
              <v-icon large>mdi-file-upload-outline</v-icon>
            </v-col>
            <v-file-input ref="initialFileInput" label="Haz clic para seleccionar" outlined counter multiple show-size
              prepend-icon="mdi-image" truncate-length="50" accept="image/*" @change="onFileChange">
              <template v-slot:selection="{ text }">
                <v-chip class="ma-2 pa-2" small close>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            Archivos soportados: WEBP, SVG, JPG.
          </section>
        </v-row>

        <!-- Sección de imágenes subidas -->
        <v-row class="d-flex justify-center">
          <v-col cols="12">
            <v-card-title>
              <v-icon left>mdi-image</v-icon>
              {{ uploadedFiles.length }} de 20 imágenes requeridas.
            </v-card-title>
            <v-card-subtitle>
              Aquí se muestran los archivos que ya se cargaron
            </v-card-subtitle>
          </v-col>
        </v-row>

        <!-- Mostrar imágenes subidas -->
        <v-row class="d-flex justify-space-around">
          <v-col cols="12" md="4" v-for="(file, index) in uploadedFiles" :key="index">
            <v-row class="d-flex">
              <v-card class="d-flex flex-row flex-md-column" max-width="374">
                <v-img contain class="fill-height ma-0" aspect-ratio="16/9" height="250" :src="file.preview"></v-img>

                <v-col>
                  <v-card-title class="body-1 font-weight-bold">
                    {{ file.name }}
                  </v-card-title>
                  <v-card-subtitle>
                    <v-list>
                      <v-list-item-content>
                        <v-list-item-title>
                          Tamaño: {{ (file.size / 1024).toFixed(2) }} KB
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          Dimensiones reales: {{ file.width }} x
                          {{ file.height }} px
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="!file.dimensionsValid" class="red--text">
                          Las dimensiones no son las esperadas.
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list>
                  </v-card-subtitle>
                </v-col>
                <v-card-actions class="d-flex justify-end">
                  <v-btn color="error" outlined rounded :icon="$vuetify.breakpoint.smAndDown"
                    @click="removeFile(index)">
                    <v-text v-if="$vuetify.breakpoint.mdAndUp">Eliminar</v-text>
                    <v-icon small :right="$vuetify.breakpoint.mdAndUp">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-row>
          </v-col>
        </v-row>





        <!-- Lista de imágenes verificadas -->
        <v-row>
          <v-col cols="12">
            <v-card-title class="font-weight-bold">
              Lista de imágenes verificadas
            </v-card-title>
            <v-list class="d-flex flex-wrap">
              <v-list-item v-for="(image, index) in expectedImages" :key="index" class="w-50">
                <v-list-item-content>

                  <v-list-item-title>{{ image.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    Dimensiones esperadas: {{ image.width }} X {{ image.height }} px
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon color="green" v-if="image.uploaded">mdi-check-circle</v-icon>
                  <v-icon color="grey" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-row>

      <!-- Servidor  -->
      <v-row v-if="consultaNueva.length >= 1">
        <!-- Sección de remplazo de archivos -->
        <v-col v-if="consultaNueva.length == 20" cols="12">
          <v-card-title class="font-weight-bold display-1">Imágenes</v-card-title>
        </v-col>
        <v-row v-if="consultaNueva.length < 20" class="d-flex justify-center">
          <v-col cols="12">
            <v-card-title class="font-weight-bold display-1">Imágenes</v-card-title>
            <v-card-subtitle class="primary--text">
              Sube las imágenes que desees remplazar
            </v-card-subtitle>
          </v-col>
          <section class="pa-16 border-dashed-thin rounded-xl">
            <v-col cols="12" class="d-flex justify-center">
              <v-icon large>mdi-file-upload-outline</v-icon>
            </v-col>
            <v-file-input ref="replaceFileInput" label="Haz clic para seleccionar" outlined counter multiple show-size
              prepend-icon="mdi-image" truncate-length="50" accept="image/*" @change="onServeChange">
              <template v-slot:selection="{ text }">
                <v-chip class="ma-2 pa-2" small close>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            Archivos soportados: WEBP, SVG, JPG.
          </section>
        </v-row>

        <!-- Mostrar imágenes subidas -->
        <v-row>
          <v-col cols="12">
            <v-card-title class="font-weight-bold">
              Lista de imágenes en el servidor
            </v-card-title>

            <v-card-subtitle>{{ consultaNueva.length }} de 20 imágenes en el servidor</v-card-subtitle>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-space-around">

          <v-col cols="12" md="4" v-for="file in consultaNueva" :key="file.id">
            <v-row class="d-flex">
              <v-col>
                <v-card class="d-flex flex-row flex-md-column" max-width="374">
                  <v-img contain class="fill-height ma-0" aspect-ratio="16/9" height="250" :src="file.url"
                    :alt="file.nombre"></v-img>

                  <v-col>
                    <v-card-title class="body-1 font-weight-bold">
                      {{ file.nombre }}
                    </v-card-title>
                    <v-card-subtitle>
                      <v-list>
                        <v-list-item-content>

                        </v-list-item-content>
                      </v-list>
                    </v-card-subtitle>
                  </v-col>
                  <!-- Actions -->
                  <v-card-actions class="d-flex justify-end">
                    <v-btn color="error" outlined rounded :icon="$vuetify.breakpoint.smAndDown"
                      @click="removeFileServe(file.id)">
                      <v-text v-if="$vuetify.breakpoint.mdAndUp">Eliminar</v-text>
                      <v-icon small :right="$vuetify.breakpoint.mdAndUp">mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>




        <!-- Lista de imágenes retornadas desde el servidor -->
        <v-row>
          <v-col cols="12">
            <v-card-title class="font-weight-bold">
              Estado de Imágenes Requeridas en Servidor
            </v-card-title>
            <v-card-subtitle>{{ consultaNueva.length }} de 20 imágenes requeridas están en el servidor</v-card-subtitle>

            <v-list class="d-flex flex-wrap">
              <v-list-item v-for="image in expectedImagesWithServerStatus" :key="image.name" class="w-50 my-auto">
                <v-list-item-content>

                  <v-list-item-avatar v-if="image.isOnServer && image.url">
                    <v-img contain :src="image.url" :alt="image.name"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-avatar v-else>
                    <v-icon large color="grey lighten-2">mdi-image-off-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>{{ image.name }}</v-list-item-title>

                  <v-list-item-subtitle>
                    Dim. esperadas: {{ image.width }} X {{ image.height }} px
                  </v-list-item-subtitle>

                </v-list-item-content>

                <v-list-item-action>
                  <v-icon large color="green" v-if="image.isOnServer">mdi-check-circle</v-icon>
                  <v-icon large color="grey" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>


      </v-row>

      <!-- Botón para confirmar y subir   -->
      <v-card-actions class="d-flex justify-end mt-8">

        <v-btn large class="primary px-8" rounded @click="submitFiles" v-if="consultaNueva.length <= 0"
          :disabled="isUploadDisabled">
          Subir Imagenes
        </v-btn>

        <v-btn v-if="consultaNueva.length >= 1" large class="primary px-8" rounded :disabled="isReplaceDisabled"
          @click="replaceFiles">
          Reemplazar Imagenes
        </v-btn>
      </v-card-actions>

      <v-snackbar v-model="snackbar" :timeout="snackbarTimeout" color="snackbarColor" top>
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text @click="snackbar = false">
            Cerrar

          </v-btn>
        </template>

      </v-snackbar>
    </v-main>

    <!-- Tab resumen -->

    <!-- Mostrar imágenes subidas -->
    
    <v-row v-if="isCurrentTabDoce" class="d-flex justify-space-around">
      <v-col cols="12" md="4" v-for="file in consultaNueva" :key="file.id">
        <v-row class="d-flex">
          <v-col>
            <v-card class="d-flex flex-row flex-md-column" max-width="374">
              <v-img contain class="fill-height ma-0" aspect-ratio="16/9" height="250" :src="file.url"></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapActions } from 'vuex'; // Importa mapActions
import { configApi } from '../../api/configApi';
import { headers } from '../../api/headers';
export default {
  props: {
    isCurrentTabDos: {
      type: Boolean,
      default: false
    },
    isCurrentTabDoce: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadedFiles: [],
      expectedImages: [], // Nueva propiedad para almacenar las imágenes esperadas
      snackbar: false,
      snackbarMessage: '',
      snackbarTimeout: 6000,
      snackbarColor: 'info',
      imagenesevento: [],
      images: [],
      name: null,
      consultaNueva: [],
    };
  },

  methods: {
    ...mapActions('solicitudevento', [
      'guardarImagenesEventoAll',
      'eliminarImagenEventoAll',
    ]),

    async refreshListImagens() {
      await axios.get(`${configApi.apiUrl}buscarimageneseventoprevio`, { headers: headers })
        .then((response) => {

          this.consultaNueva = response.data && response.data.data ? response.data.data : [];

        })

    },

    async onFileChange(files) {
      // Validar los archivos antes de procesarlos

      const validationResult = this.validateFiles(files);
      if (validationResult !== true) {
        // Mostrar mensaje de error al usuario
        this.snackbarMessage = validationResult;
        this.snackbar = true;

        // Resetear el input de archivos
        this.$refs.initialFileInput.value = null;
        return;
      }

      // Si la validación es exitosa, procedemos a procesar los archivos
      const newFiles = await Promise.all(
        Array.from(files).map(async (file) => {

          const sinext = file.name.split('.')

          const preview = URL.createObjectURL(file);

          // Obtener dimensiones de la imagen
          const dimensions = await this.getImageDimensions(file);
          const tolerance = 1; // Tolerancia en píxeles
          const expectedDimensions = this.getExpectedDimensions(file.name); // Array de parejas
          const dimensionsValid = expectedDimensions.some(([w, h]) => {
            const expectedW = Number(w); // Convierte a número
            const expectedH = Number(h); // Convierte a número
            // Comprueba que sean números válidos Y que las dimensiones coincidan
            return !isNaN(expectedW) && !isNaN(expectedH) &&
              Math.abs(dimensions.width - expectedW) <= tolerance &&
              Math.abs(dimensions.height - expectedH) <= tolerance;
          });




          return {
            file,
            name: file.name,
            nombre: sinext[0],
            type: file.type,
            size: file.size,
            selected: false,
            preview,
            width: dimensions.width,
            height: dimensions.height,
            dimensionsValid,
          };
        })
      );

      const validFiles = newFiles.filter((file) => file.dimensionsValid);
      const invalidFiles = newFiles.filter((file) => !file.dimensionsValid);

      // Agregar los archivos válidos a la lista existente
      this.uploadedFiles = [...this.uploadedFiles, ...validFiles];

      // Actualizar el estado de las imágenes esperadas
      this.updateExpectedImages(validFiles);

      if (invalidFiles.length > 0) {
        // Mostrar mensajes de error de manera amigable
        this.snackbarMessage =
          'Algunas imágenes no tienen las dimensiones correctas y no se subirán.';
        this.snackbar = true;
      }


      this.$refs.initialFileInput.value = null;
    },
    async onServeChange(files) {


      const successfullyProcessedFiles = [];
      const errorMessages = [];
      const validNames = [
        'miniatura_320',
        'miniatura_600',
        'imagen_card_desktop',
        'imagen_card_mobile',
        'banner_x1_360',
        'banner_x1_600',
        'banner_x1_960',
        'banner_x1_1264',
        'banner_x1_1440',
        'banner_x1_1880',
        'banner_x2_720',
        'banner_x2_1200',
        'banner_x2_1920',
        'banner_x2_2528',
        'banner_x2_2880',
        'precios_mobile',
        'precios_desktop',
        'mapa_mobile',
        'mapa_desktop',
        'disenoboleta',
      ];
      const maxSize = 2 * 1024 * 1024;
      const currentTotal = this.consultaNueva.length + this.uploadedFiles.length;
      if (currentTotal + files.length >= 21) {
        this.snackbarMessage = `No puedes exceder las 20 imágenes en total (actualmente ${currentTotal}).`;
        this.snackbar = true;
        this.$refs.replaceFileInput.value = null; // Resetear input
        return; // Detener procesamiento
      }

      for (const file of files) {


        let isValid = true;
        let fileErrorMessage = '';

        const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');


        // b. Validar contra duplicados del SERVIDOR
        const existsOnServer = this.consultaNueva.some(
          serverImage => serverImage.nombre === fileNameWithoutExtension
        );

        if (existsOnServer) {
          isValid = false;
          fileErrorMessage = `El archivo "${file.name}" ya existe en el servidor.`;
          errorMessages.push(fileErrorMessage);
          continue;
        }

        // c. Validar contra duplicados LOCALES (en uploadedFiles)
        const existsLocally = this.uploadedFiles.some(
          localFile => localFile.nombre === fileNameWithoutExtension
        );

        if (existsLocally) {
          isValid = false;
          fileErrorMessage = `El archivo "${file.name}" ya está en la lista para subir.`;
          errorMessages.push(fileErrorMessage);
          console.groupEnd();
          continue;
        }

        // d. Validaciones básicas (Nombre, Tipo, Tamaño)
        if (!validNames.includes(fileNameWithoutExtension)) {
          isValid = false; fileErrorMessage = `"${file.name}" nombre no permitido.`;
          console.groupEnd();
          continue;
        }
        if (!['image/webp', 'image/jpeg', 'image/svg+xml'].includes(file.type)) {
          isValid = false; fileErrorMessage = `"${file.name}" (${file.type}) formato no permitido.`;
          errorMessages.push(fileErrorMessage);
          console.groupEnd();
          continue;
        }
        if (file.size > maxSize) {
          isValid = false; fileErrorMessage = `"${file.name}" supera 2MB.`;
          errorMessages.push(fileErrorMessage);
          console.groupEnd();
          continue;
        }



        try {
          const dimensions = await this.getImageDimensions(file);

          const expectedDimensions = this.getExpectedDimensions(file.name);

          const tolerance = 1;
          const dimensionsValid = expectedDimensions.some(([w, h]) => {
            const expectedW = Number(w); const expectedH = Number(h);
            return !isNaN(expectedW) && !isNaN(expectedH) && Math.abs(dimensions.width - expectedW) <= tolerance && Math.abs(dimensions.height - expectedH) <= tolerance;
          });


          if (!dimensionsValid) {
            isValid = false;
            const expectedDimsString = expectedDimensions.map(d => `${d[0]}x${d[1]}`).join(' o ');
            fileErrorMessage = `"${file.name}" tiene dimensiones ${dimensions.width}x${dimensions.height}px. Se esperaba ${expectedDimsString}px.`;
            errorMessages.push(fileErrorMessage);
            console.groupEnd();

            continue;
          }

          // Si pasa todas las validaciones
          if (isValid) {

            const preview = URL.createObjectURL(file);
            const processedFile = { file, name: file.name, nombre: fileNameWithoutExtension, type: file.type, size: file.size, preview, width: dimensions.width, height: dimensions.height, dimensionsValid: true };
            successfullyProcessedFiles.push(processedFile);

          }

        } catch (error) {
          isValid = false;
          fileErrorMessage = `Error procesando dimensiones de "${file.name}": ${error}`;
          errorMessages.push(fileErrorMessage);
          console.groupEnd();
          continue;
        }

      }



      // 3. Actualizar Estado y Mostrar Feedback
      if (successfullyProcessedFiles.length > 0) {

        this.uploadedFiles = [...this.uploadedFiles, ...successfullyProcessedFiles];

        this.updateExpectedImages(successfullyProcessedFiles);

      }

      if (errorMessages.length > 0) {

        this.snackbarMessage = `Se encontraron problemas: ${errorMessages.join('. ')}`;
        this.snackbar = true;
      } else if (successfullyProcessedFiles.length > 0) {
        //console.log("onServeChange: Todos los archivos seleccionados fueron válidos y agregados.");
      }
      this.$refs.replaceFileInput.value = null;

    },
    getImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        if (file.type === 'image/svg+xml') {
          // Procesar SVG: leer como texto
          reader.onload = function (e) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(e.target.result, 'image/svg+xml');
            const svg = doc.querySelector('svg');
            if (svg) {
              let width = svg.getAttribute('width');
              let height = svg.getAttribute('height');
              // Si no se definen width o height, usa el viewBox
              if ((!width || !height) && svg.getAttribute('viewBox')) {
                const viewBox = svg.getAttribute('viewBox').split(' ');
                width = viewBox[2];
                height = viewBox[3];
              }
              width = parseFloat(width) || 0;
              height = parseFloat(height) || 0;
              resolve({ width, height });
            } else {
              // Si no se encontró un <svg> válido, resolver con 0
              resolve({ width: 0, height: 0 });
            }
          };
          reader.onerror = function () {
            resolve({ width: 0, height: 0 });
          };
          reader.readAsText(file);
        } else {
          // Para imágenes rasterizadas (PNG, JPG, etc.)
          reader.onload = function (e) {
            const image = new Image();
            image.onload = function () {
              resolve({ width: image.width, height: image.height });
            };
            image.onerror = function () {
              resolve({ width: 0, height: 0 });
            };
            image.src = e.target.result;
          };
          reader.onerror = function () {
            resolve({ width: 0, height: 0 });
          };
          reader.readAsDataURL(file);
        }
      });

    },

    getExpectedDimensions(fileName) {
      const validNames = {
        miniatura_320: [[320, 240]],
        miniatura_600: [[600, 600]],
        imagen_card_desktop: [[512, 640]],
        imagen_card_mobile: [[320, 480]],
        banner_x1_360: [[720, 1080]],
        banner_x1_600: [[1200, 1728]],
        banner_x1_960: [[1920, 708]],
        banner_x1_1264: [[2528, 932]],
        banner_x1_1440: [[2880, 1280]],
        banner_x1_1880: [[1880, 692]],
        banner_x2_720: [[1440, 2160]],
        banner_x2_1200: [[2400, 3456]],
        banner_x2_1920: [[3840, 1416]],
        banner_x2_2528: [[5056, 1864]],
        banner_x2_2880: [[5760, 2560]],
        precios_mobile: [[480, 720]],
        precios_desktop: [[720, 480]],
        mapa_mobile: [[480, 720], [960, 1440]], // Dos opciones para mapa_mobile
        mapa_desktop: [[1280, 720]],
        disenoboleta: [[794, 1124]],
      };
      const fileNameWithoutExtension = fileName
        .split('.')
        .slice(0, -1)
        .join('.');
      return validNames[fileNameWithoutExtension] || [[0, 0]];
    },

    getExpectedImageList() {
      // Crear una lista de imágenes esperadas con su estado inicial
      const validNames = {
        miniatura_320: [[320, 240]],
        miniatura_600: [[600, 600]],
        imagen_card_desktop: [[512, 640]],
        imagen_card_mobile: [[320, 480]],
        banner_x1_360: [[720, 1080]],
        banner_x1_600: [[1200, 1728]],
        banner_x1_960: [[1920, 708]],
        banner_x1_1264: [[2528, 932]],
        banner_x1_1440: [[2880, 1280]],
        banner_x1_1880: [[1880, 692]],
        banner_x2_720: [[1440, 2160]],
        banner_x2_1200: [[2400, 3456]],
        banner_x2_1920: [[3840, 1416]],
        banner_x2_2528: [[5056, 1864]],
        banner_x2_2880: [[5760, 2560]],
        precios_mobile: [[480, 720]],
        precios_desktop: [[720, 480]],
        mapa_mobile: [[480, 720], [960, 1440]], // Dos opciones para mapa_mobile
        mapa_desktop: [[1280, 720]],
        disenoboleta: [[794, 1124]],
      };

      return Object.keys(validNames).map((name) => {
        // 1. Obtener el array de pares de dimensiones (asegura un valor por defecto)
        const dimensionsArray = validNames[name] || [[0, 0]];

        // 2. Tomar SIEMPRE el *primer* par de dimensiones para la lista
        //    Incluso para mapa_mobile, mostraremos solo el primero en esta lista de resumen.
        const firstDimensionPair = dimensionsArray[0]; // Ej: [320, 240]

        // 3. Crear el objeto con width y height asignados correctamente
        return {
          name: name,                   // Nombre base
          width: firstDimensionPair[0],  // Ancho del primer par
          height: firstDimensionPair[1], // Alto del primer par
          uploaded: false,              // Estado inicial
        };
      });
    }, // Fin de getExpectedImageList
    updateExpectedImages(uploadedFiles) {
      // Marcar las imágenes que ya han sido subidas
      uploadedFiles.forEach((file) => {
        const fileNameWithoutExtension = file.name
          .split('.')
          .slice(0, -1)
          .join('.');
        const image = this.expectedImages.find(
          (img) => img.name === fileNameWithoutExtension
        );
        if (image) {
          image.uploaded = true;
        }
      });
    },
    validateFiles: function (files) {

      if (files.length > 20) {
        return 'Solo puedes subir hasta 20 imágenes.';
      }
      const validNames = [
        'miniatura_320',
        'miniatura_600',
        'imagen_card_desktop',
        'imagen_card_mobile',
        'banner_x1_360',
        'banner_x1_600',
        'banner_x1_960',
        'banner_x1_1264',
        'banner_x1_1440',
        'banner_x1_1880',
        'banner_x2_720',
        'banner_x2_1200',
        'banner_x2_1920',
        'banner_x2_2528',
        'banner_x2_2880',
        'precios_mobile',
        'precios_desktop',
        'mapa_mobile',
        'mapa_desktop',
        'disenoboleta',
      ];

      for (let file of files) {
        const fileNameWithoutExtension = file.name
          .split('.')
          .slice(0, -1)
          .join('.');

        // Verificar si el archivo ya ha sido agregado
        const alreadyExists = this.uploadedFiles.some((uploadedFile) => {
          const uploadedFileNameWithoutExtension = uploadedFile.name
            .split('.')
            .slice(0, -1)
            .join('.');
          return (
            uploadedFileNameWithoutExtension === fileNameWithoutExtension
          );
        });
        if (alreadyExists) {
          return `El archivo ${file.name} ya ha sido agregado. No puedes subir archivos duplicados.`;
        }

        if (!validNames.includes(fileNameWithoutExtension)) {
          return `El archivo ${file.name
            } debe tener uno de los siguientes nombres: ${validNames.join(
              ', '
            )}.`;
        }
        if (!['image/webp', 'image/jpeg', 'image/svg+xml',].includes(file.type)) {
          return `El archivo ${file.name} no es un formato permitido. Solo se aceptan WEBP,JPG y SVG.`;
        }
        const maxSize = 2 * 1024 * 1024;
        if (file.size > maxSize) {
          return `El archivo ${file.name} supera el tamaño máximo de 2MB.`;
        }
      }
      return true;
    },

    removeFile(index) {
      // Llamar a la acción del store
      this.eliminarImagenEventoAll(index);

      // También eliminar del arreglo local y actualizar el estado
      const removedFile = this.uploadedFiles.splice(index, 1)[0];
      URL.revokeObjectURL(removedFile.preview);

      // Actualizar el estado de las imágenes esperadas
      const fileNameWithoutExtension = removedFile.name
        .split('.')
        .slice(0, -1)
        .join('.');
      const image = this.expectedImages.find(
        (img) => img.name === fileNameWithoutExtension
      );
      if (image) {
        image.uploaded = false;
      }

    },
    async submitFiles() {
      if (this.uploadedFiles.length !== 20) {
        this.snackbarMessage = 'Debes subir exactamente 20 imágenes.';
        this.snackbarColor = 'warning';
        this.snackbar = true;
        return;
      }
      const validFiles = this.uploadedFiles.filter(
        (file) => file.dimensionsValid
      );
      if (validFiles.length !== this.uploadedFiles.length) {
        this.snackbarMessage = 'Algunas imágenes en la lista tienen dimensiones incorrectas.';
        this.snackbarColor = 'warning';
        this.snackbar = true;
        return;
      }

      try {

        // Extraemos solo el objeto File de cada elemento
        const filesToSend = validFiles.map(item => item.file);

        for (const file of filesToSend) {
          await this.$store.dispatch('imagen/newImagen64', {
            imagen: file,
            metodo: 'Nuevo',
            nombre: file.name
          });
        }
        this.snackbarMessage = 'Imágenes subidas con éxito.'; // Mensaje de éxito
        this.snackbarColor = 'success'; // Color de éxito
        this.snackbar = true;
        // Limpiar los archivos si es necesario
        this.uploadedFiles = [];
        await this.refreshListImagens();
      } catch (error) {
        console.error('Error al procesar las imágenes:', error);
        // Reemplazo de alert
        this.snackbarMessage = 'Error al subir las imágenes. Intenta de nuevo.';
        this.snackbarColor = 'error';
        this.snackbar = true;
      }
    },
    async replaceFiles() {

      const validFiles = this.uploadedFiles.filter(
        (file) => file.dimensionsValid
      );
      if (validFiles.length !== this.uploadedFiles.length) {
        this.snackbarMessage = 'Algunas imágenes seleccionadas tienen dimensiones incorrectas.';
        this.snackbarColor = 'warning';
        this.snackbar = true;
        return;
      }
      // Añadir verificación por si no quedan archivos válidos
      if (validFiles.length === 0 && this.uploadedFiles.length > 0) {
        this.snackbarMessage = 'Ninguna de las imágenes seleccionadas tiene las dimensiones correctas.';
        this.snackbarColor = 'error';
        this.snackbar = true;
        return;
      }

      try {

        // Extraemos solo el objeto File de cada elemento
        const filesToSend = validFiles.map(item => item.file);

        for (const file of filesToSend) {
          await this.$store.dispatch('imagen/newImagen64', {
            imagen: file,
            metodo: 'Nuevo',
            nombre: file.name
          });
        }
        this.snackbarMessage = 'Imágenes reemplazadas/subidas con éxito.'; // Mensaje de éxito
        this.snackbarColor = 'success'; // Color de éxito
        this.snackbar = true;
        await this.refreshListImagens();

        // Limpiar los archivos si es necesario
        this.uploadedFiles = [];
      } catch (error) {
        console.error('Error al procesar las imágenes en replaceFiles:', error);
        // Reemplazo de alert
        this.snackbarMessage = 'Error al subir/reemplazar las imágenes. Intenta de nuevo.';
        this.snackbarColor = 'error';
        this.snackbar = true;
      }

    },
    async removeFileServe(fileId) {

      await axios.get(`${configApi.apiUrl}eliminar_imagen/` + fileId, { headers: headers })
        .then((response) => {
          //console.log('me devuelve del backend', response);
        })

      await this.refreshListImagens()

    },
  },

  computed: {
    isUploadDisabled() {
      return this.uploadedFiles.length !== 20;
    },
    isFullImages() {
      return this.consultaNueva.length;
    },

    expectedImagesWithServerStatus() {
      if (!Array.isArray(this.consultaNueva) || !Array.isArray(this.expectedImages)) {
        return [];
      }
      // Crear un Map para buscar rápidamente la imagen completa del servidor por su nombre
      const serverImageMap = new Map(this.consultaNueva.map(img => [img.nombre, img]));

      // Mapear la lista de imágenes ESPERADAS
      return this.expectedImages.map(expectedImg => {
        const serverImage = serverImageMap.get(expectedImg.name); // Busca el objeto completo del servidor
        const isOnServer = !!serverImage; // True si se encontró algo

        return {
          ...expectedImg, // Copia name, width, height de la imagen esperada
          isOnServer: isOnServer,
          // Añade url e id DEL SERVIDOR si la imagen existe allí
          id: isOnServer ? serverImage.id : null,
          url: isOnServer ? serverImage.url : null,
        };
      });
    },

    isReplaceDisabled() {
      // Deshabilitar si:
      // 1. El servidor ya tiene 20 imágenes O
      // 2. No hay archivos locales seleccionados/preparados para subir
      return this.consultaNueva.length >= 20 || this.uploadedFiles.length === 0;
    }
  },
  watch: {
    isCurrentTabDoce(){
      if(isCurrentTabDoce == true){
        axios.get(`${configApi.apiUrl}buscarimageneseventoprevio`, { headers: headers })
          .then((response) => {
            this.consultaNueva = response.data && response.data.data ? response.data.data : [];
          })
      }
      
    },

    isFullImages(newVal) {
      this.$emit("updateImageCount", newVal);
    }
  },
  created() {

    this.expectedImages = this.getExpectedImageList();


    axios.get(`${configApi.apiUrl}buscarimageneseventoprevio`, { headers: headers })
      .then((response) => {
        this.consultaNueva = response.data && response.data.data ? response.data.data : [];
      })

  },
}
</script>
<style scoped>
.border-dashed-thin {
  border: 1px dashed #cac5cb;
}

.mx-2 {
  margin-left: 8px;
  margin-right: 8px;
}
</style>
